import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import './CoreValues.css';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';

const CoreValues = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
      document.title = "Core Values – Bay Capital Advisors";
      
      // Find and update the favicon
      let favicon = document.querySelector("link[rel~='icon']");
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      favicon.href = logo; // Use your logo as favicon
      
      return () => {
        // Reset title when component unmounts if needed
        document.title = "Bay Capital Advisors";
      };
    }, []);
            
              const toggleMobileMenu = () => {
                setIsMobileMenuOpen(!isMobileMenuOpen);
              };
            
              const closeMobileMenu = () => {
                setIsMobileMenuOpen(false);
              };
  return (
    <div className="core-values-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
      <section class="hero6">
    
      <div class="header-overlay9"></div>
    
    <header class="header6">
    <NavBar />
  </header>
      <header className="core-values-header">
        
          <h1>CORE VALUES</h1>
        
      </header>
      </section>

      <div className="core-values-content">
        <h2>Core Values and Business Principles</h2>
        
        <div className="core-value">
          <h3>Client Focus</h3>
          <hr className="value-divider" />
          <p>Being responsive to each of our clients’ needs and achieving each of their objectives is our number one priority.</p>
        </div>

        <div className="core-value">
          <h3>Integrity</h3>
          <hr className="value-divider" />
          <p>
            Honesty and integrity are the core values that guide all of our dealings with clients and impact the services we provide.
            Bay Capital Advisors adheres to all applicable ethical rules and codes of conduct.
          </p>
        </div>

        <div className="core-value">
          <h3>Confidentiality</h3>
          <hr className="value-divider" />
          <p>Maintaining the confidentiality of the information that we receive from our clients is, and will always be, of paramount concern.</p>
        </div>

        <div className="core-value">
          <h3>Excellence</h3>
          <hr className="value-divider" />
          <p>We strive for excellence in everything we do, from the people we hire to the products and services we deliver.</p>
        </div>

        <div className="core-value">
          <h3>Innovation</h3>
          <hr className="value-divider" />
          <p>Bay Capital Advisors will constantly strive to pioneer new and unique business practices and technology platforms that create more value for our clients.</p>
        </div>

       

        <div className="core-value">
          <h3>Professionalism</h3>
          <hr className="value-divider" />
          <p>Bay Capital Advisors will provide each of our clients with a sophisticated level of service. We will bring best practices and the highest quality standards to the clients we serve.</p>
        </div>

        <div className="core-value">
          <h3>Teamwork</h3>
          <hr className="value-divider" />
          <p>Each member of the Bay Capital Advisors team supports these principles and is dedicated to the success of our clients and to working with them to achieve their business objectives.</p>
        </div>

      </div>


      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
  );
};

export default CoreValues;
